import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import MemberMultiSelect, { type MemberOption } from "../MemberMultiSelect";
import { modalFormFieldLabelSx } from "../modalFormStyles";

interface StakeholdersFieldProps {
  /** Full team member list to pick from. */
  members: MemberOption[];
  /** Selected teamMember ids. */
  value: string[];
  onChange: (ids: string[]) => void;
  /** Assignee id to exclude — stakeholders must not overlap the assignee. */
  excludeId?: string;
}

/**
 * Project "Stakeholders" form field (label + member multi-select). Shared by
 * the create and edit project modals so the field stays identical in both —
 * change it here once instead of in each modal.
 */
export default function StakeholdersField({
  members,
  value,
  onChange,
  excludeId,
}: StakeholdersFieldProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box>
      <Typography component="label" variant="body2" sx={modalFormFieldLabelSx(theme)}>
        {t("project.stakeholders")}
      </Typography>
      <MemberMultiSelect
        members={members}
        value={value}
        onChange={onChange}
        excludeId={excludeId}
        placeholder={t("project.stakeholdersPlaceholder")}
        size="small"
      />
    </Box>
  );
}
